export default {
      id: "filter-outline-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#filter-outline-usage",
      toString: function () {
        return this.url;
      }
    }